import React from 'react';
import config from 'config/config';

import SitebarDropdown from './sitebarDropdown';
import Badge from 'src/components/badges/badge';

import classNames from 'classnames';
import i18n from 'i18next';

class UserMenu extends React.Component {
  onLogoutClick = (event) => {
    event.preventDefault();
    this.props.logout();
  }

  getMenuItems = () => {
    const { lang, user } = this.props;
    const userName = user.username;
    return [
      {name: i18n.t('Profile'), icon: 'icon-profile-1', link: `/user/${userName}` },
      {name: i18n.t('Find people near me'), icon: 'icon-people', link: '/people-near-me'},
      {name: i18n.t('Your needs'), icon: 'icon-newsfeed', link: '/your-needs'},
      {name: i18n.t('Discover'), icon: 'icon-compass', link: '/discover', badge: <Badge content={i18n.t('NEW')} type="new" /> },
      {name: i18n.t('Settings'), icon: 'icon-settings', link: '/settings'},
      {name: i18n.t('Help'), icon: 'icon-help', link: config.community[lang].support, target: '_blank' },
      {name: i18n.t('Log out'), icon: 'icon-logout', link: '/', onClick: this.onLogoutClick},
    ];
  }

  render() {
    const { user, open, handleClick } = this.props;
    const avatarImageUrl = user.avatarImageUrl;
    const userName = user.username;
    const userClasses = classNames({
      'user-menu': true,
      'user-menu--open': open,
    });

    return <div className={userClasses}>
      <a href="#" className="user-menu__heading hidden-xs" onClick={handleClick}>
        <span className="avatar avatar--xsmall">
          <img className="avatar avatar--centered avatar--xsmall" src={avatarImageUrl} alt={userName} />
        </span>
      </a>
      <SitebarDropdown open={open} marginLeft={-167} width={215}>
        <ul>
          {this.getMenuItems().map(item =>
            <li key={item.icon} onClick={item.onClick}>
              <a href={item.link} target={item.target}>
                <span className={`user-menu__icon ${item.icon}`} />
                {item.name}{' '}
                {item.badge}
              </a>
            </li>
          )}
        </ul>
      </SitebarDropdown>
    </div>;
  }
}

export default UserMenu;



// WEBPACK FOOTER //
// ./src/components/siteBar/userMenu.js